/**
 * Created by robert.lavoie on 6/28/17.
 */

import { Component, Renderer2, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

// Models
import { Filter } from '../../models';

/**
 *
 * @class
 * JobSearchFiltersMobileMenuComponent
 *
 * @description
 * This component is used to display the filter options on small screen sizes
 * Its a menu that will fly out from left to right
 *
 */
@Component({
  templateUrl: './job-search-filters-mobile-menu.component.html',
  selector: 'job-search-filters-mobile-menu',
  styleUrls: ['./job-search-filters-mobile-menu.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in <=> out', animate('200ms ease-in-out'))
    ]),
  ]
})
export class JobSearchFiltersMobileMenuComponent{

  // An array of all the available filters
  @Input() availableFilters: Filter[];

  // The site theme color
  @Input() themeColor: string;

  // Emits and event to the host when a user hits the applyFilters button
  @Output() applyFilters: EventEmitter<any> = new EventEmitter();

  // Emits and event to the host when a user hits the resetFilters button
  // This will reset all the filters
  @Output() resetAllFilters: EventEmitter<any> = new EventEmitter();

  // The state for the filter menu which is either in or out
  public mobileFilterMenuState: string = 'out';


  constructor(private renderer: Renderer2) {
  }


  /**
   * Toggles the display of the mobile filter options menu
   */

  toggleMobileFilterMenu(){
    this.mobileFilterMenuState = this.mobileFilterMenuState === 'out' ? 'in' : 'out';
  }



  /**
   * And sets overflow styles for the body tag so the body no longer scrolls
   * when the filter menu is open
   */
  toggleBodyOverflow(){
    if (this.mobileFilterMenuState === 'in'){
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
    }else{
      this.renderer.removeStyle(document.body, 'overflow');
    }
  }


  /**
   * Closes the menu and dispatches the applyFilters event to the host
   */
  applyFiltersHandler(){

    this.toggleMobileFilterMenu();

    this.applyFilters.emit();

  }


  /**
   * Closes the menu and dispatches the resetFilters event to the host
   */
  resetFiltersHandler(){

    this.toggleMobileFilterMenu();

    this.resetAllFilters.emit();

  }

  /**
   * Toggles the selected state of the filters
   *
   * @param { number }
   */
  onSelectionChange(filtersIndex: number, optionsIndex: number){

    // Reset all selected items to false if the filter type is a radio button
    if (this.availableFilters[filtersIndex]['type'] === 'radio'){
      this.availableFilters[filtersIndex]['options'].forEach((item) => {
        item['selected'] = false;
      });
    }

    this.availableFilters[filtersIndex]['options'][optionsIndex]['selected'] = this.availableFilters[filtersIndex]['options'][optionsIndex]['selected'] === true ? false : true;

  }

}
